<template>
  <div class="detail">
    <div class="content">
      <a-spin v-if="loading" tip="Loading..."><div class="spin-content"></div></a-spin>
      <div v-if="sItem == 1">
        <h2>“启航助学”专项基金</h2>
        <div class="text">
          <p>在2015-2018年间，“启航助学”专项基金共资助426名苏州贫困家庭学子助学金213万元，惠及10余所中小学和大学，为家庭贫困但成绩优异的同学们顺利完成学业提供保障。</p>
          <p>2015年资助108名贫困学生共计54万元；</p>
          <p>2016年资助106名贫困学生共计53万元；</p>
          <p>2017年资助106名贫困学生共计53万元；</p>
          <p>2018年资助106名贫困学生共计53万元。</p>
          <img src="http://fundation.goldmantis.com:8444/files/pros/gy11.png"/>
          <img src="http://fundation.goldmantis.com:8444/files/pros/gy12.png"/>
        </div>
      </div>
      <div v-if="sItem == 2">
        <h2>苏州大学金螳螂建筑学院教育发展基金</h2>
        <div class="text">
          <p>金螳螂为支持苏州大学金螳螂建筑学院的发展，在苏州大学设立了苏大金螳螂建筑学院教育发展基金。自2012年起，分别设立特色学科建设、国际化办学、金螳螂奖助学金、金螳螂奖教金，2017年起增设高素质人才建设项目。</p>
          <p>“特色学科建设”用于学院举办学科评审、专业评审、各类学术活动等，促进学科、专业的提升和排名，扩大学院在业内的知名度和影响力。</p>
          <p>“国际化办学”用于支持我院师生出境研修，与世界一流的建筑设计院和国际知名大学交流学习。</p>
          <p>“金螳螂奖助学金”用于资助品学兼优的本科学生，激励他们勤奋学习、努力进取、全面发展。“金螳螂奖教金”用于表彰先进，用于奖励在教学、科研、管理等工作较为突出的教职员工。</p>
          <img src="http://fundation.goldmantis.com:8444/files/pros/gy21.png"/>
          <img src="http://fundation.goldmantis.com:8444/files/pros/gy22.png"/>
        </div>
      </div>
      <div v-if="sItem == 3">
        <h2>“情暖心窝”爱心救助基金</h2>
        <div class="text">
          <p>“情暖心窝”专项基金是由金螳螂公益慈善基金会于2015年在苏大附属儿童医院捐赠设立，累计捐赠150万元，用于帮助患先天性心脏病或重度听力障碍的贫困儿童得到及时救治、发展儿童健康慈善事业，回报社会。2017年-2018年间资助24名贫困家庭患儿75.2万元，让恶性重大疾病的贫困患者获得应有救治，其中西藏籍藏族患者4名、贵州籍苗族患者4名。</p>
          <img src="http://fundation.goldmantis.com:8444/files/pros/gy31.png"/>
          <img src="http://fundation.goldmantis.com:8444/files/pros/gy32.png"/>
          <img src="http://fundation.goldmantis.com:8444/files/pros/gy33.png"/>
          <img src="http://fundation.goldmantis.com:8444/files/pros/gy34.png"/>
        </div>
      </div>
      <div v-if="sItem == 4">
        <h2>“生命之光”爱心救助专项基金</h2>
        <div class="text">
          <p>2015年，金螳螂公益慈善基金会在苏大附属第一、第二医院捐赠成立“生命之光”爱心救助专项基金，为预期治疗效果较好但经济困难的恶性血液病患者、经济困难的恶性肿瘤患者等其他需要进行重大手术而经济困难的患者提供医疗救助，专项基金成立4年来累计救助80名重大疾病的贫困患者，累计资助金额300万元。2017年，“生命之光”爱心救助基金拓展到了新疆克州人民医院，截至目前已累计资助22名当地维吾尔族患者。</p>
          <img src="http://fundation.goldmantis.com:8444/files/pros/gy41.png"/>
        </div>
      </div>
      <div v-if="sItem == 5">
        <h2>金螳螂“工业园区慈善医疗”专项基金</h2>
        <div class="text">
          <p>2015年，金螳螂公益慈善基金会捐资在苏州工业园区捐赠成立“金螳螂慈善医疗专项基金”，从困难家庭医疗保障需求出发，探索建立了医疗救助与公益慈善的衔接，协助完善困难家庭慈善医疗救助，使慈善资源作为医疗救助的重要补充。自2015年起连续4年累计为334名救助对象发放慈善医疗救助金。</p>
          <img src="http://fundation.goldmantis.com:8444/files/pros/gy51.png"/>
          <img src="http://fundation.goldmantis.com:8444/files/pros/gy52.png"/>
        </div>
      </div>
      <div v-if="sItem == 6">
        <h2>老人日间照料中心</h2>
        <div class="text">
          <p>苏州的老年人口已连续三年创历史新高，其中80周岁以上高龄人口已突破25万人，福利性养老机构和子女供养的养老服务模式，远远不能满足不断增长的老年人口的需要，养老问题亟待社会公益力量给予支持和帮助。2015年起，为让居家养老的困难老人获得应有的照料，打造5分钟养老帮扶圈，连续捐资在苏州古城区建成4所老人日间照料中心，分别位于娄门社区，西北街社区、金狮社区，察院场社区，为他们提供便捷的助餐、助浴、助医等服务，惠泽人数达千余人。</p>
          <img src="http://fundation.goldmantis.com:8444/files/pros/gy61.png"/>
          <img src="http://fundation.goldmantis.com:8444/files/pros/gy62.png"/>
        </div>
      </div>
      <div v-if="sItem == 7">
        <h2>幸福亮居工程</h2>
        <div class="text">
          <p>为了帮助苏州大市范围内部分贫困残疾人家庭改善居家生活环境，消除居家生活障碍，提升生活品质，金螳螂公益慈善基金会联合苏州市残联、苏州市慈善总会、苏州市残疾人基金会共同发起了“幸福亮居”改造工程，并计划对苏州市部分贫困残疾人家庭进行家居无障碍设施环境改造。</p>
          <p>2018年5月，在苏州姑苏区完成了试点4户残疾人家庭居住环境的改造，到2018年12月末，在苏州大市范围市共计完成52户残疾人家庭居住环境的改造。</p>
          <img src="http://fundation.goldmantis.com:8444/files/pros/gy71.png"/>
          <img src="http://fundation.goldmantis.com:8444/files/pros/gy72.png"/>
        </div>
      </div>
      <div v-if="sItem == 8">
        <h2>“千人工匠”精准帮扶计划</h2>
        <div class="text">
          <p>金螳螂慈善公益基金会受贵州省、陕西省政府委托，自2016年5月起，金螳螂公益慈善基金会的工作人员通过苏州派驻当地挂职官员多次深入大山，实地调研走访10多个乡村了解民情、了解需求。实地调研后联合苏州市、贵州省、陕西省两地政府以及社会组织，利用金螳螂的专业资源，启动“千人工匠”精准帮扶计划，旨在打破“代际贫穷”，尽早实现“一人就业，全家脱贫”的精准脱贫目标，项目实施以来，累计共为贵州省松桃县305名苗族建档立卡贫困户解决就业问题，为陕西省延川县、山阳县两地共680名建档立卡的贫困群众提供就业技能培训并推荐就业。</p>
          <img src="http://fundation.goldmantis.com:8444/files/pros/gy81.png"/>
          <img src="http://fundation.goldmantis.com:8444/files/pros/gy82.png"/>
        </div>
      </div>
      <div v-if="sItem == 9">
        <h2>盐城阜宁灾区<br/>为灾区施援手，金螳螂在行动</h2>
        <div class="text">
          <p>6月23日下午14:30左右，江苏盐城阜宁县等地遭受冰雹、龙卷风袭击，造成大量房屋倒塌、人员伤亡、道路受损等灾害。灾害发生后，金螳螂公益慈善基金会代表全体金螳螂人驱车赶往灾区，将鲜花、慰问金带去受灾员工家中，祝愿伤者早日康复。此次金螳螂公益慈善基金会共捐助6户受灾员工家庭。其中，十一分公司深化设计鲍伟伟的家位于灾害最严重的村落之一，龙卷风侵袭后，鲍伟伟的家一片残垣断壁，原本粉刷一新的婚房也已倒塌，万幸的是家中亲人并无大碍。另一位十一分公司员工蔡延成的家也损毁严重，年迈的外婆更是遭受严重骨折住进了医院。来自公司的慰问如同雪中送炭，受灾员工深刻感受到金螳螂就是为员工遮风避雨的家！金螳螂慈善基金会致力于扶贫济困，关爱弱势群体；关注民生，注重教育事业。自然灾害的发生虽然让我们体验到大自然的无情，但灾后的救援与善行又让我们深深地感受到了真情与温暖。努力成为“员工值得依托、实现自我的公司”是金螳螂的企业使命之一，此次灾害发生时，许多受灾员工仍坚守在岗位，无法回家探望家人，公司第一时间赶往灾区并反馈受灾情况，让员工安心、放心！天灾无情人有情，希望灾区人们早日走出伤痛，共同努力，重建家园。</p>
          <img src="http://fundation.goldmantis.com:8444/files/pros/gy91.png"/>
          <img src="http://fundation.goldmantis.com:8444/files/pros/gy92.png"/>
        </div>
      </div>
      <div v-if="sItem > 9">
        <div v-html="ndetail.richText"></div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'newd',
  data () {
    return {
      loading: true,
      sItem: 0,
      ndetail: {}
    }
  },
  components: {
  },
  mounted() {
    this.init();
  },
  methods: {
    init () {
      if(this.$route.params.id){
        this.sItem = this.$route.params.id;
      }
      if(this.sItem > 9){
        this.$store.dispatch('ajaxProDetail',{
          id: this.$route.params.id,
          jobcode: 'L075703'
        }).then((result) => {
          this.pdetail = result;
        })
      }else{
        this.loading = false;
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  @import '../../scss/views/detail';
</style>
